import { render, staticRenderFns } from "./NewsDetailOne.vue?vue&type=template&id=06fe311d&scoped=true"
import script from "./NewsDetailOne.vue?vue&type=script&lang=js"
export * from "./NewsDetailOne.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailOne.vue?vue&type=style&index=0&id=06fe311d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fe311d",
  null
  
)

export default component.exports